import React from "react";

function IconHelp() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            fill="none"
            viewBox="0 0 28 28"
        >
            <path
                fill="#9A9A9A"
                d="M15.165 21c0 .645-.525 1.165-1.165 1.165A1.17 1.17 0 0112.835 21c0-.64.525-1.165 1.165-1.165s1.165.52 1.165 1.165z"
            ></path>
            <path
                fill="#9A9A9A"
                d="M14 28C6.278 28 0 21.722 0 14S6.278 0 14 0s14 6.278 14 14-6.278 14-14 14zm0-26.25C7.246 1.75 1.75 7.246 1.75 14S7.246 26.25 14 26.25 26.25 20.754 26.25 14 20.754 1.75 14 1.75z"
            ></path>
            <path
                fill="#9A9A9A"
                d="M14 17.21a.878.878 0 01-.875-.875V15.16c0-1.11.706-2.105 1.75-2.477 1.395-.492 2.33-1.974 2.33-3.057a3.211 3.211 0 00-3.21-3.21 3.212 3.212 0 00-3.21 3.21.878.878 0 01-.876.875.878.878 0 01-.875-.875 4.967 4.967 0 014.96-4.96 4.967 4.967 0 014.96 4.96c0 1.947-1.536 4.014-3.5 4.703a.873.873 0 00-.584.826v1.176a.87.87 0 01-.87.88z"
            ></path>
        </svg>
    );
}

export default IconHelp;
